import authac from './authac'

export { authac }